import { responseError } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import withDraft from '@/utils/draftHelper';
import actions from '../constants';

const fetchSubscriptions = withDraft((draft) => {
  draft.subscriptions.readStatus = states.PENDING;
  draft.subscriptions.readErrors = [];
});

const fetchSubscriptionsSuccess = withDraft((draft, action) => {
  draft.subscriptions.readStatus = states.SUCCESS;
  draft.subscriptions.readErrors = [];
  draft.subscriptions.results = action.response.items;
});

const fetchSubscriptionsError = withDraft((draft, action) => {
  draft.subscriptions.readStatus = states.ERROR;
  draft.subscriptions.readErrors = [responseError(action)];
});

const toggleShowSubscription = withDraft((draft) => {
  draft.subscriptions.open = !draft.subscriptions.open;
});

const toggleSubscription = withDraft((draft) => {
  draft.subscriptions.saveStatus = states.PENDING;
  draft.subscriptions.saveErrors = [];
});

const toggleSubscribeSuccess = withDraft((draft, action) => {
  draft.subscriptions.open = false;
  draft.subscriptions.saveStatus = states.SUCCESS;
  draft.subscriptions.saveErrors = [];
  draft.subscriptions.results = draft.subscriptions.results.filter(
    (subscription) => subscription.event !== action.event,
  );
  draft.subscriptions.results.push(...action.subscriptions);
});

const toggleSubscriptionError = withDraft((draft, action) => {
  draft.subscriptions.open = false;
  draft.subscriptions.saveStatus = states.ERROR;
  draft.subscriptions.saveErrors = [responseError(action)];
});

export default {
  [actions.FETCH_SUBSCRIPTIONS]: fetchSubscriptions,
  [actions.FETCH_SUBSCRIPTIONS_SUCCESS]: fetchSubscriptionsSuccess,
  [actions.FETCH_SUBSCRIPTIONS_ERROR]: fetchSubscriptionsError,
  [actions.TOGGLE_SHOW_SUBSCRIPTION]: toggleShowSubscription,
  [actions.TOGGLE_SUBSCRIPTION]: toggleSubscription,
  [actions.TOGGLE_SUBSCRIBE_SUCCESS]: toggleSubscribeSuccess,
  [actions.TOGGLE_UNSUBSCRIBE_SUCCESS]: toggleSubscribeSuccess,
  [actions.TOGGLE_SUBSCRIPTION_ERROR]: toggleSubscriptionError,
};
